import { useMemo } from 'react';
import { getRandomId } from '../utils/randomId';

export const useRandomId = () => {
  const randomId = useMemo(() => getRandomId(), []);
  return randomId;
};
